import { getHubSpotAuthorizationUrl } from "api/landlord/landlord";
import { useState } from "react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Input,
  Show
} from "shared/components";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";
import { useSettingsController } from "views/settings-integration/controller";

interface SecondStepProps {
  setCurrentStep: (step: Step) => void;
  closeModal: () => void;
  selectedIntegration: string;
}

export const SecondStep = ({
  setCurrentStep,
  closeModal,
  selectedIntegration
}: SecondStepProps) => {
  const { updateSettings, isUpdateSettingsPending } = useSettingsController();

  const [googleAnalyticsId, setGoogleAnalyticsId] = useState("");

  const handleAuthorizeHubSpot = async () => {
    const data = await getHubSpotAuthorizationUrl();

    window.open(data.authorization_url, "HubSpot Auth");
  };

  return (
    <>
      <Show if={selectedIntegration === "Google Analytics"}>
        <Input
          label="GA account ID"
          required
          id="test"
          placeholder="G-XYZ"
          value={googleAnalyticsId}
          onChange={(e) => setGoogleAnalyticsId(e.target.value)}
        />

        <div className="flex justify-end gap-2 mt-4">
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.BASE}
            onClick={() => setCurrentStep(Step.FIRST)}
          >
            Cancel
          </Button>
          <Button
            loading={isUpdateSettingsPending}
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            onClick={() => {
              updateSettings({ googleAnalyticsId: googleAnalyticsId }).then(
                () => {
                  closeModal();
                }
              );
            }}
            disabled={!googleAnalyticsId}
          >
            Continue
          </Button>
        </div>
      </Show>

      <Show if={selectedIntegration === "HubSpot"}>
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          onClick={handleAuthorizeHubSpot}
        >
          Connect to HubSpot
        </Button>
      </Show>
    </>
  );
};
